module.exports = __webpack_public_path__ + "img/imcLogo.a81eb264.png";